module.exports = __webpack_public_path__ + "img/orange_017.9532f84c.png";